import React, { useRef, useState } from "react";
import ProductBanner from "./components/product-banner";
import { EMPLOYEE_LOAN_INFO, PRODUCTS } from "../../constants/products";
import ProductBenefit, {
  ProductBenefitContent,
} from "./components/product-benefit";
import lowInterestIcon from "../../assets/images/products/low-interest.png";
import instantPayIcon from "../../assets/images/products/instant-pay.png";
import transparantIcon from "../../assets/images/products/transparancy.png";
import formIcon from "../../assets/images/products/form.png";
import extraBenefitIcon from "../../assets/images/products/extra-benefit.png";
import costBenefitIcon from "../../assets/images/products/cost-benefit.png";
import {
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import ProductClosingStatement from "./components/product-closing-statement";
// import { Link } from "react-router";
import { NAVIGATIONS } from "../..";
import ProductInterest from "./components/product-interest";
// import ProductEmployeeSimulation from "./components/product-employee-simulation";
import ProductPartner from "./components/product-partner";
import CheckCompany from "./components/check-company";
import ProductCard from "../../components/products/product-card";
import employeeLogo from "../../assets/images/employee.png";
import companyLogo from "../../assets/images/company.png";
import { ENV } from "../../config/env";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faUsers } from "@fortawesome/free-solid-svg-icons";
import ProductHow, { ProductHowContent } from "./components/product-how";
import { Link } from "react-router";
import { CONTACTS } from "../../constants";
// import ProductCard from "../../components/products/product-card";
import ProductEmployeeSimulation from "./components/product-employee-simulation";

const CONTENTS: ProductBenefitContent[] = [
  {
    title: "Benefit Tambahan untuk Karyawan",
    image: extraBenefitIcon,
    description:
      "Peduli karyawan, bebas stres finansial, produktivitas meningkat.",
    key: "company",
  },
  {
    title: "Fleksibilitas Pemberian Fasilitas Pinjaman",
    image: formIcon,
    description: `Perusahaan dapat mengatur siapa yang dapat memanfaatkan fasilitas pinjaman dan limit yang diberikan.`,
    key: "company",
  },
  {
    title: "Tidak Mengganggu Cashflow Perusahaan",
    image: costBenefitIcon,
    description: `Pengembalian pinjaman dilakukan perusahaan setelah memotong gaji karyawan dalam 1x transfer.`,
    key: "company",
  },
  {
    title: "Terima Biaya Instan",
    image: instantPayIcon,
    description:
      "Dana diterima dalam waktu 2 jam setelah konfirmasi pihak HRD.",
    key: "employee",
  },
  {
    title: "Biaya Transparan",
    image: transparantIcon,
    description: `Biaya dibayarkan di muka sebesar Rp ${Intl.NumberFormat("id-ID").format(EMPLOYEE_LOAN_INFO.adminFee)} per transaksi. Tidak ada biaya tersembunyi lainnya.`,
    key: "employee",
  },
  {
    title: "Bunga Rendah",
    image: lowInterestIcon,
    description: `Bunga dimulai dari ${Intl.NumberFormat("id-ID").format(EMPLOYEE_LOAN_INFO.interestRate.start)}% per bulan disesuaikan dengan penghasilan karyawan dan tenor yang diambil.`,
    key: "employee",
  },
];

const EMPLOYEE_CARD = [
  {
    bannerDescription: "",
    bannerImage: "",
    description: "",
    key: "contact",
    link: "",
    shortDescription: "Bantu karyawan mendapatkan pendanaan dengan cepat",
    shortImage: companyLogo,
    title: "",
    buttonText: "Daftar sebagai Perusahaan",
  },
  {
    bannerDescription: "",
    bannerImage: "",
    description: "",
    key: "",
    link: ENV.EMPLOYEE_LOAN + "/login",
    shortDescription: (
      <React.Fragment>
        <OverlayTrigger
          overlay={
            <Tooltip>
              Pengajuan Employee Loan hanya dapat dilakukan di perusahaan yang
              telah terdaftar di produk Employee Loan Pohon Dana
            </Tooltip>
          }
        >
          <div>
            Ajukan pinjaman dari tempatmu bekerja{" "}
            <span className="text-primary-main fw-bold text-size-sub-body-2">
              *
            </span>
          </div>
        </OverlayTrigger>
      </React.Fragment>
    ),
    shortImage: employeeLogo,
    title: "",
    buttonText: "Masuk Sekarang",
  },
];

const PARTNER = {
  title1: "Perusahaan yang telah menggunakan",
  title2: "Employee Loan",
  titleDescription: "",
  product: "employee-loan",
  description: "",
};

function EmployeeLoan() {
  const product = PRODUCTS.employeeLoan;

  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [showType, setShowType] = useState("company");

  const handleToggle = () => {
    if (showType === "company") {
      setShowType("employee");
    } else {
      setShowType("company");
    }
  };
  const handleCheck = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (sectionRef.current) {
      const element = sectionRef.current;
      const offset = 60;
      if (element) {
        const top =
          element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };

  const CONTENT_HOW: ProductHowContent[] = [
    {
      key: "company",
      title: "Kontak Pohon Dana",
      description: (
        <React.Fragment>
          Hubungi tim Pohon Dana melalui halaman{" "}
          <Link to={NAVIGATIONS.contact}>Kontak Kami</Link> atau melalui email
          di <a href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a> dan
          masukkan informasi perusahaan Anda.
        </React.Fragment>
      ),
    },
    {
      key: "company",
      title: "Kunjungan Perusahaan",
      description: (
        <React.Fragment>
          Tim Pohon Dana akan melakukan verifikasi dan demo produk ke perusahaan
          Anda.
        </React.Fragment>
      ),
    },
    {
      key: "company",
      title: "Kerja Sama Terbentuk",
      description: (
        <React.Fragment>
          Apabila Perjanjian Kerja Sama ditandatangani dan akun terbentuk,
          bagian HRD dapat mulai mendaftarkan karyawan.
        </React.Fragment>
      ),
    },
    {
      key: "employee",
      title: "Cek Perusahaan Kamu",
      description: (
        <React.Fragment>
          Pastikan perusahaan kamu bekerja telah memiliki kerja sama dengan
          Pohon Dana produk {product.title}. Kamu juga bisa{" "}
          <a href="/" onClick={handleCheck}>
            cek di sini
          </a>
          .
        </React.Fragment>
      ),
    },
    {
      key: "employee",
      title: "Pendaftaran",
      description: (
        <React.Fragment>
          Masuk melalui{" "}
          <a href={ENV.EMPLOYEE_LOAN} target="_blank" rel="noreferrer">
            platform {product.title}
          </a>{" "}
          Pohon Dana dan masukkan nomor HP dan KTP seperti yang diinput oleh
          HRD-mu.
        </React.Fragment>
      ),
    },
    {
      key: "employee",
      title: "Verifikasi dan Pengajuan",
      description: (
        <React.Fragment>
          Lakukan verifikasi data dan foto selfie melalui platform Pohon Dana.
          Setelah selesai terverifikasi, kamu bisa langsung mulai mengajukan
          pinjaman.
        </React.Fragment>
      ),
    },
  ];

  return (
    <div className="main-container" id="product-page">
      <ProductBanner product={product} />
      <Container className="my-5">
        <div className="text-size-body-head-2 text-center">
          Lihat informasi sebagai
        </div>
        <div className="d-flex justify-content-center gap-0 gap-md-2 align-items-center mb-4">
          <div
            className="text-primary text-size-body-head-2 fw-normal me-3 pt-2 clickable"
            onClick={() => setShowType("company")}
          >
            Perusahaan
          </div>
          <div>
            <Form.Switch
              className="switch-employee-loan-show-type text-size-sub-headline"
              label={
                <span onClick={handleToggle}>
                  {showType === "company" ? (
                    <FontAwesomeIcon icon={faBuilding} />
                  ) : (
                    <FontAwesomeIcon icon={faUsers} />
                  )}
                </span>
              }
              checked={showType !== "company"}
              onChange={handleToggle}
            />
          </div>
          <div
            className="text-primary text-size-body-head-2 fw-normal pt-2 clickable"
            onClick={() => setShowType("employee")}
          >
            Karyawan
          </div>
        </div>
        <ProductBenefit
          title={
            <React.Fragment>
              <div className="mb-2">
                <span className="text-primary-main">Keuntungan</span>{" "}
                {product.title}
              </div>
            </React.Fragment>
          }
          contents={CONTENTS.filter((a) => a.key === showType)}
        />
      </Container>
      <Container className="mt-5">
        <ProductHow
          reverse={showType !== "company"}
          product={{
            ...product,
            title: showType === "company" ? "Perusahaan" : "Karyawan",
          }}
          subtitle={
            <React.Fragment>
              <span className="text-primary-main">Proses Pendaftaran</span>{" "}
              untuk{" "}
            </React.Fragment>
          }
          caption={`Pendaftaran ${product.title}`}
          contents={CONTENT_HOW.filter((a) => a.key === showType)}
        />
      </Container>
      <ProductInterest
        position="left"
        title={
          <React.Fragment>
            <span className="text-primary-main">Biaya</span> Pinjaman untuk{" "}
            <span className="text-primary-main">Karyawan</span>
          </React.Fragment>
        }
        interestMin={EMPLOYEE_LOAN_INFO.interestRate.start}
        interestMax={EMPLOYEE_LOAN_INFO.interestRate.end}
        caption={
          <React.Fragment>
            <div>
              Provisi dan biaya keterlambatan -{" "}
              <span className="fw-bold">Rp 0</span>
            </div>
            <div>
              Biaya admin - Rp{" "}
              {Intl.NumberFormat("id-ID").format(EMPLOYEE_LOAN_INFO.adminFee)} /
              transaksi
            </div>
          </React.Fragment>
        }
      />
      <ProductEmployeeSimulation />
      <ProductPartner data={PARTNER} />

      <Container
        className="my-5 pt-4"
        ref={(el) => {
          sectionRef.current = el;
        }}
      >
        <CheckCompany
          filters={["employeeLoan"]}
          subtitle="Pengajuan Employee Loan hanya dapat dilakukan di perusahaan yang telah terdaftar di produk Employee Loan Pohon Dana"
          // foundMessage="Kamu dapat mulai mengajukan Employee Loan dengan mendaftar sesuai nomor HP yang didaftarkan oleh HRD-mu."
          notFoundMessage="Hubungi perusahaan kamu atau berikan informasi kontak HRD agar kami dapat mendaftarkan perusahaanmu."
        />
        <div className="mt-5 text-size-title-2 fw-extra-bold text-secondary-dark text-center">
          Bergabung Sekarang
        </div>
        <Row className="justify-content-center">
          {EMPLOYEE_CARD.map((p) => {
            return (
              <Col
                key={`more-product-${p.key}`}
                lg={4}
                md={6}
                sm={12}
                className="mt-4"
              >
                <ProductCard product={p} />
              </Col>
            );
          })}
        </Row>
      </Container>

      <Container className="my-5 pt-4">
        <ProductClosingStatement
          caption=""
          title=""
          product={product}
          buttonText="Ajukan Pinjaman"
          additionalInfo={<React.Fragment></React.Fragment>}
        />
      </Container>
    </div>
  );
}

export default EmployeeLoan;
